import { combineReducers } from 'redux';
import projects from './reducers/projects';
import authUser from './reducers/authUser';
import common from './reducers/common';
import { routerReducer } from 'react-router-redux';

// The state must return entirely from reducers.
// A reducer is just a JavaScript function. 
// A reducer takes two parameters: the current state and an action.
export default combineReducers({
    projects,
    authUser,
    common,
    router: routerReducer
});


// WEBPACK FOOTER //
// ./src/redux/reducer.js